export enum Range {
    _24h = '24h',
    _30d = '30d',
    _90d = '90d',
}